export default __webpack_public_path__ + "bb0e3a4e20cf463fbd6a428e3f8cc5be.woff2";